<template>
  <v-dialog persistent v-model="show" width="500">
    <v-card>
      <v-toolbar dense dark tile color="error darken-1">
        <v-toolbar-title
          >Agregar número telefónico a lista negra</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-3">
        <v-row no-gutters>
          <v-col cols="12">
            <p>
              A continuación, ingresa el número telfónico que deseas bloquear.
              Se inhabilitará la posibilidad de redimir beneficios y quedará
              registrado el bloqueo con el id de esta emisión
            </p>
          </v-col>
          <v-col cols="12">
            <v-form v-model="isFormValid" ref="form" lazy-validation>
              <v-text-field
                v-model="form.telefono"
                label="Número telefónico"
                :rules="[$rules.required, $rules.numeric, $rules.longDigit(10)]"
                :maxlength="10"
              ></v-text-field>
            </v-form>
          </v-col>
          <v-col cols="12">
            <div class="d-flex justify-end">
              <v-btn text color="secondary" class="mr-2" @click="$emit('close')"
                >No, cancelar</v-btn
              >
              <v-btn
                color="error darken-1"
                :disabled="!isFormValid"
                @click="submit"
              >
                <v-icon small class="mr-2">mdi-lock</v-icon>
                <span>Bloquear</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        telefono: "",
      },
      isFormValid: false,
    };
  },

  methods: {
    submit() {
      this.$refs.form.validate();
      if (this.isFormValid) {
        this.$emit("confirm", this.form.telefono);
      }
    },
  },
};
</script>
